export { default } from "~/components/product/CrossSellingShelf";

export const eager = true;
export const sync = true;
